import { LockIcon } from 'assets/icons';
import { classnames } from 'helpers/utils';
import styles from './private-toggle-item.module.scss';

interface PrivateToggleItemProps {
  isPrivate: boolean;
  onToggle: () => void;
  disabled?: boolean;
}

// The "Make private" row of an album's or a memory's … menu: one button that
// flips the setting, with a switch showing where it stands. (common/toggle is
// a button itself, so it can't sit inside a menu row without double clicks.)
export const PrivateToggleItem = ({
  isPrivate,
  onToggle,
  disabled = false,
}: PrivateToggleItemProps) => (
  <button
    type="button"
    role="menuitemcheckbox"
    aria-checked={isPrivate}
    className={styles.item}
    onClick={onToggle}
    disabled={disabled}
  >
    <LockIcon className={styles.icon} />
    <span
      className={classnames(
        styles.label,
        'text__body__semi__bold__small__gray700',
      )}
    >
      Make private
    </span>
    <span
      className={classnames(styles.switch, { [styles.switchOn]: isPrivate })}
      aria-hidden
    />
  </button>
);
